export default __webpack_public_path__ + "static/media/step_B_UA.d6572973.png";